import React, { useState, useEffect, useCallback } from 'react';
import { PageHeader, message, Button, Spin, Pagination } from 'antd';

import Meta from '../../../../components/Meta';
import Fallback from '../../../../components/Fallback';
import { Container, ItemsList, PaginationContainer } from './styles';

import { RssFeedItem } from './rss-feed-item';
import { UpsertRssFeedModal } from './upsert-rss-feed-modal';
import { RssFeedsFilters } from './filters';
import RssFeedsApi from '../../../../services/sdks/rss-feeds';

const breadcrumb = {
	routes: [
		{ breadcrumbName: 'Início' },
		{ breadcrumbName: 'Agentes de IA' },
		{ breadcrumbName: 'Mensagens' },
	],
	style: { marginBottom: 12 },
};

const RssFeeds = () => {
	const [fallback, setFallback] = useState({ initialData: true });
	const [rssFeeds, setRssFeeds] = useState([]);
	const [showUpsertModal, setShowUpsertModal] = useState(false);
	const [handlingRssFeed, setHandlingRssFeed] = useState(null);
	const [totalItems, setTotalItems] = useState(0);
	const [params, setParams] = useState({
		title: '',
		category: undefined,
		region: undefined,
		pageNumber: 1,
	});

	const fetchRssFeeds = useCallback(async () => {
		setFallback((prev) => ({ ...prev, fetchingRssFeeds: true }));

		try {
			const { data } = await RssFeedsApi.listRssFeeds({
				...params,
				pageNumber: params.pageNumber - 1,
				pageSize: 12,
			});

			setRssFeeds(data.rssFeeds);
			setTotalItems(data.total);
		} catch (error) {
			message.error('Houve um erro ao buscar os feeds, tente novamente');
		}

		setFallback((prev) => ({ ...prev, initialData: false, fetchingRssFeeds: false }));
	}, [params]);

	useEffect(() => {
		fetchRssFeeds();
	}, [fetchRssFeeds]);

	if (fallback?.initialData) {
		return <Fallback title='Carregando' message='Por favor aguarde...' />;
	}

	return (
		<>
			<Meta title='Feeds RSS' />

			<PageHeader
				title='Feeds RSS'
				breadcrumb={breadcrumb}
				extra={[
					<Button
						key='create-banner'
						type='ghost'
						size='large'
						icon='plus-circle'
						onClick={() => setShowUpsertModal(true)}>
						Criar Feed RSS
					</Button>,
				]}>
				<RssFeedsFilters filters={params} setFilters={setParams} />

				<Container>
					<Spin spinning={fallback.fetchingRssFeeds}>
						<ItemsList>
							{rssFeeds.map((rssFeed) => (
								<RssFeedItem
									key={rssFeed._id}
									data={rssFeed}
									onDelete={fetchRssFeeds}
									onUpdate={(rssFeed) => {
										setShowUpsertModal(true);
										setHandlingRssFeed(rssFeed);
									}}
								/>
							))}
						</ItemsList>
					</Spin>

					<PaginationContainer>
						<Pagination
							onChange={(pageNumber) => setParams({ ...params, pageNumber })}
							total={totalItems}
							current={params.pageNumber}
						/>
					</PaginationContainer>
				</Container>
			</PageHeader>

			<UpsertRssFeedModal
				initialData={handlingRssFeed}
				isVisible={showUpsertModal}
				onCancel={() => {
					setShowUpsertModal(false);
					setHandlingRssFeed(null);
				}}
				onSubmit={({ action, data }) => {
					setShowUpsertModal(false);
					setHandlingRssFeed(null);
					setRssFeeds((prev) =>
						action === 'CREATE' ? [data, ...prev] : prev.map((r) => (r._id === data._id ? data : r))
					);
				}}
			/>
		</>
	);
};

export default RssFeeds;
